module.exports = __webpack_public_path__ + "img/faq8.8df2fd5f.svg";